import ActionCardReplacementsProcessor from '../webPlayTitleReplacementsProcessors/ActionCardReplacementsProcessor.js'
import StaticReplacementsProcessor from '../webPlayTitleReplacementsProcessors/StaticReplacementsProcessor.js'

export default class RedirectLinkReplacementProcessor {
  constructor(actionCardModel, playTerm, senderEmail) {
    this.actionCardModel = actionCardModel
    this.acReplacementProcessor = new ActionCardReplacementsProcessor(this.actionCardModel)
    this.staticReplacementProcessor = new StaticReplacementsProcessor(playTerm, senderEmail)
  }
  process(template) {
    const [urlTemplate, paramsTemplate] = (template || '').split('?')
    const widgets = [...this.actionCardModel.getSearchService()]
      .flatMap(x => x.data.widgets || [])
    const url = processReplacements.call(this, widgets, urlTemplate)
    const params = new URLSearchParams(paramsTemplate)

    params.keys().forEach(key => {
      params.set(key, processReplacements.call(this, widgets, params.get(key)))
    })

    return `${url}?${params.toString()}`
  }
}

function processReplacements(widgets, template) {
  if (!template) return ''

  let result = this.acReplacementProcessor.process(template)
  result = this.staticReplacementProcessor.process(result)

  for (const widget of widgets) {
    const {code, value} = widget
    if (code) {
      result = result.replaceAll(`$${code}`, value || '')
    }
  }
  
  return result
}
